import React from 'react';
import { useSettings } from '../context/SettingsContext';
import * as Icons from 'lucide-react';

const ICON_MAP = {
  'cloud-rain': Icons.CloudRain,
  'handshake': Icons.Handshake,
  'shield-check': Icons.ShieldCheck,
  'spray': Icons.SprayCan,
  'truck': Icons.Truck,
  'phone': Icons.PhoneCall,
};

const ServiceSection = () => {
  const { settings } = useSettings();
  const items = settings?.service_items || [];
  if (items.length === 0) return null;

  return (
    <section className="py-4 sm:py-6 md:py-10" data-testid="service-section">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 sm:mb-8">
          <h2 className="text-3xl md:text-4xl font-bold text-sky-700">Service</h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-2 gap-3 sm:gap-x-12 sm:gap-y-10">
          {items.map((item, i) => {
            const Icon = ICON_MAP[item.icon] || Icons.CheckCircle;
            return (
              <div
                key={i}
                className="flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left gap-2 sm:gap-5 bg-white/70 sm:bg-transparent rounded-2xl sm:rounded-none p-3 sm:p-0 border border-sky-100 sm:border-0"
                data-testid={`service-item-${i}`}
              >
                <div className="flex-shrink-0 w-11 h-11 sm:w-16 sm:h-16 rounded-xl sm:rounded-2xl bg-sky-50 flex items-center justify-center text-sky-600">
                  <Icon className="w-6 h-6 sm:w-8 sm:h-8" />
                </div>
                <div>
                  <h3 className="text-[15px] sm:text-xl font-bold text-sky-700 mb-1 sm:mb-2 leading-tight">{item.title}</h3>
                  <p className="text-[13px] sm:text-base text-neutral-600 leading-relaxed">{item.text}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
